import usersSlice from './usersSlice';

export * from './thunks';

export default usersSlice;
